import Header from "@/components/Header";
import ScrollProgress from "@/components/ScrollProgress";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import AboutSection from "@/components/AboutSection";
import QuoteSection from "@/components/QuoteSection";
import ProcessSection from "@/components/ProcessSection";
import TestimonialSection from "@/components/TestimonialSection";
import KeynoteSection from "@/components/KeynoteSection";
import InsightsSection from "@/components/InsightsSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="homepage" className="bg-[#121418] text-[#F9F6F0] min-h-screen overflow-x-hidden">
      <ScrollProgress />
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ProblemSection />
        <SolutionSection />
        <AboutSection />
        <QuoteSection />
        <ProcessSection />
        <TestimonialSection />
        <KeynoteSection />
        <InsightsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
